module.exports = __webpack_public_path__ + "static/img/mobile-enroll-box.71fa2ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/template/mobile-enroll-box.png
// module id = Brzs
// module chunks = 17